import React from 'react'

const Refresh = () => {
  return (
    <svg height="16px" version="1.1" viewBox="0 0 16 16" width="16px">
      <title/>
      <desc/>
      <defs/>
      <g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1">
        <g fill="currentColor" id="Core" transform="translate(-424.000000, -340.000000)">
          <g id="refresh" transform="translate(424.000000, 340.000000)">
            <path d="M13.6,2.4 C12.2,0.9 10.2,0 8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C11.7,16 14.8,13.4 15.7,10 L13.6,10 C12.8,12.3 10.6,14 8,14 C4.7,14 2,11.3 2,8 C2,4.7 4.7,2 8,2 C9.7,2 11.1,2.7 12.2,3.8 L9,7 L16,7 L16,0 L13.6,2.4 L13.6,2.4 Z" id="Shape"/>
          </g>
        </g>
      </g>
    </svg>
  )
}


export default Refresh



// WEBPACK FOOTER //
// ./src/components/icons/Refresh.js